import React from "react";
import { useQuery } from "@apollo/client";
import { logEvent } from "firebase/analytics";
import { analytics } from "../../App/Analytics";

import {
  GetPostRepliesPaginatedV2,
  GetPostEchoesPaginatedV2,
} from "../../graphql/customWebappQueries/expandedPostQueries";

import {
  GetPostEchoesPaginatedQuery,
  GetPostEchoesPaginatedQueryVariables,
  GetPostRepliesPaginatedQuery,
  GetPostRepliesPaginatedQueryVariables,
  PostInfoV2Fragment,
} from "../../API";
import {
  LoadingView,
  ErrorView,
} from "../../Components/RecurringSmallViews/RecurringSmallViews";
import "../../Infrastucture/MissingStd";
import { PostCard } from "../../Components/PostCard/PostCard";
import { makePostCardConfig } from "../../Infrastucture/ComponentConfigBackendBridge";

import "./ExpandedPostLoadingLists.css";

export function PostAllRepliesComponent(postId: string): JSX.Element {
  logEvent(analytics, "screen_view", {
    firebase_screen: "ExpandedPost_AllReplies",
    firebase_screen_class: "ExpandedPostLoadingLists",
    post_id: postId,
  });

  const { loading, error, data } = useQuery<
    GetPostRepliesPaginatedQuery,
    GetPostRepliesPaginatedQueryVariables
  >(GetPostRepliesPaginatedV2, {
    errorPolicy: "ignore",
    variables: {
      postId,
      nextPageToken: null,
    },
  });

  if (loading) {
    return LoadingView();
  }
  if (error) {
    return ErrorView();
  }

  const listPayload = data?.getPost?.replies;
  if (listPayload) {
    const postInfoItems = listPayload.items
      .tawkitExtensions()
      .compactMap((maybeItem) => {
        if (maybeItem) {
          const item: PostInfoV2Fragment = maybeItem;
          return item;
        }
        return null;
      });

    const postCards = postInfoItems.map((postInfo) => (
      <div className="PostList-PostCard-Wrapper">
        <PostCard {...makePostCardConfig(postInfo)} />
      </div>
    ));

    return <div>{postCards}</div>;
  }

  return ErrorView("Unexpected.");
}

export function PostAllEchoesComponent(postId: string): JSX.Element {
  logEvent(analytics, "screen_view", {
    firebase_screen: "ExpandedPost_AllEchoes",
    firebase_screen_class: "ExpandedPostLoadingLists",
    post_id: postId,
  });

  const { loading, error, data } = useQuery<
    GetPostEchoesPaginatedQuery,
    GetPostEchoesPaginatedQueryVariables
  >(GetPostEchoesPaginatedV2, {
    errorPolicy: "ignore",
    variables: {
      postId,
      nextPageToken: null,
    },
  });

  if (loading) {
    return LoadingView();
  }
  if (error) {
    return ErrorView();
  }

  const listPayload = data?.searchPosts;
  if (listPayload) {
    const postInfoItems = listPayload.items
      .tawkitExtensions()
      .compactMap((maybeItem) => {
        if (maybeItem) {
          const item: PostInfoV2Fragment = maybeItem;
          return item;
        }
        return null;
      });

    const postCards = postInfoItems.map((postInfo) => (
      <div className="PostList-PostCard-Wrapper">
        <PostCard {...makePostCardConfig(postInfo)} />
      </div>
    ));

    return <div>{postCards}</div>;
  }

  return ErrorView("Unexpected.");
}
